import * as ethers from "ethers";
import {magic} from "@/utils/magic";
import {dpayAbi} from "@/abis/dpayAbi";

export async function getMagicDpayBalance(): Promise<bigint> {
    const provider = new ethers.BrowserProvider(magic.rpcProvider);
    const signer = await provider.getSigner();
    const contract = new ethers.Contract(import.meta.env.VITE_DPAY_TOKEN_ADDRESS_ETHEREUM, dpayAbi, signer);
    return await contract.balanceOf((await magic.user.getMetadata()).publicAddress);
}